import { render, staticRenderFns } from "./GlassBreakagePersonalPropertyDamagesOriginQuestion.vue?vue&type=template&id=5f50838b"
import script from "./GlassBreakagePersonalPropertyDamagesOriginQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakagePersonalPropertyDamagesOriginQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports